<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col class="mt-12" cols="12" sm="10" lg="8" xl="6">
        <h2 class="text-h4 font-weight-bold">How does it work?</h2>
        <h2 class="text-subtitle-1">
          On 100 ASA, all images are curated by the community. We publish only a
          small number of photos weekly, giving them the exposure they deserve.
        </h2>
        <div class="mt-12">
          <div>
            <v-timeline :dense="$vuetify.breakpoint.smAndDown" align-top>
              <v-timeline-item
                v-for="(item, i) in items"
                :key="i"
                :color="item.color"
                :icon="item.icon"
                fill-dot
              >
                <v-card :color="item.color" outlined dark>
                  <v-card-title class="text-h6">
                    {{ item.title }}
                  </v-card-title>
                  <v-card-text
                    :class="
                      $vuetify.theme.dark
                        ? 'grey darken-4'
                        : 'primary--text secondary'
                    "
                    class="pt-4"
                  >
                    <p class="text-body-1 ma-0">
                      {{ item.content }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          icon: 'fal fa-hands-heart fa-md',
          color: '#1E88E5',
          title: 'Help the community',
          content:
            'Our main goal is to create a community of photographers curated by photographers. This is why we invite you to curate photos. Beside it, writing useful comments will help you to build your own reputation.'
        },
        {
          icon: 'fal fa-cloud-upload fa-md',
          color: '#7CB342',
          title: 'Upload your photo',
          content:
            "Uploading photos to 100ASA couldn't be simpler - .jpg or .png formats are accepted with a resolutions up to 200MP or a file size of 25MB."
        },
        {
          icon: 'fal fa-sack-dollar fa-md',
          color: '#E65100',
          title: 'Earn Tokens',
          content:
            'Tokens are the 100ASA virtual currency that allows you to submit photos for curation and more... To earn Tokens you need to give feedback on other photos on the website.'
        },
        {
          icon: 'fal fa-users fa-md',
          color: '#8E24AA',
          title: 'Community curation',
          content:
            "Once posted for curation, your photos awaits attention in the curation area of the website for up to seven days. This allows others to engage and offer valuable insights into your work. After the curation period, your photo will be directed to one of 100ASA's galleries based on the rating and commenting of other users."
        },
        {
          icon: 'fal fa-bullseye-pointer fa-md',
          color: '#FB8C00',
          title: 'Check your photo popularity',
          content:
            'You can see photos that you\'ve submitted for curation along with their popularity on the "Manage Photos" screen.'
        },
        {
          icon: 'fal fa-images fa-md',
          color: '#43A047',
          title: 'Photo publishing',
          content:
            "Depending on the popularity your photos will be published to one of 100ASA's galleries getting the exposure they deserve."
        },
        {
          icon: 'fal fa-seedling fa-md',
          color: '#D81B60',
          title: 'Keep receiving feedback',
          content:
            "Once your photos have been published on any of 100ASA's galleries, they will still receive comments and feedback from the community and have a chance to be promoted to higher galleries."
        },
        {
          icon: 'fal fa-star fa-md',
          color: '#3949AB',
          title: 'Elite gallery',
          content:
            '100ASA carefully reviews photos on the Prime gallery based on a number of different criteria. Photos of the highest quality are hand-picked by our team to ensure the top quality, and published on the Elite gallery.'
        }
      ]
    }
  },
  head({ $seo }) {
    return $seo({
      title: 'How Does It Work?',
      description: 'Find out how our photography community works. What makes 100ASA unique. How to get your photos from curation to top galleries.'
    })
  }
}
</script>
